export default __webpack_public_path__ + "static/4-17f3d201795ec8d91b3d654c89adf87a.webp";